import {
  Box,
  Container,
  Grid,
  Grid2,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import { BestSeller } from "../../data/raw";
import { GET_LAYOUTS } from "../../redux/apis";
import "./Home.css";
import { useDispatch } from "react-redux";
import { ProductGridView } from "../../components/productCard/productGridView";
import SnackBarComponent from "../../components/snackbar/snackbar";
import { addToCart } from "../../utilities/cartUtils";
import { axiosPublicInstance } from "../../redux/axiosInstance";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const useStyles = makeStyles({
  mainPart: {
    backgroundColor: "transparent",
    // width: (WIDTH * 90) / 100,
  },
  titleText: {
    color: "#000000",
    marginBottom: (HEIGHT / 100) * 1,
    fontSize: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    display: "block",
  },
  container: {
    height: (HEIGHT / 100) * 33,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  headLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  catBox: {
    height: (HEIGHT / 100) * 11.5,
    width: (HEIGHT / 100) * 11.5,
    borderColor: "#C4C4C4",
    borderWidth: 1,
    borderRadius: 8,
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: (WIDTH / 100) * 2,
  },
  catBox1: {
    height: (HEIGHT / 100) * 11.5,
    width: (HEIGHT / 100) * 11.5,
    borderColor: "#C4C4C4",
    borderWidth: 1,
    borderRadius: 8,
    alignItems: "center",
    paddingTop: 10,
    paddingBottom: 10,
    marginRight: (WIDTH / 100) * 5,
  },
  catText: {
    color: "#030712",
    fontSize: 10,
    textAlign: "center",
    height: 40,
    textAlignVertical: "center",
    lineHeight: 12,
  },
  BestBox: {
    // height: HEIGHT / 100 * 25,
    // width: WIDTH < 400 ? WIDTH * 60 / 100 : 'auto',
    width: WIDTH < 400 ? (WIDTH * 45) / 100 : (WIDTH / 100) * 15,
    // width: WIDTH,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#C4C4C4",
    padding: (WIDTH / 100) * 1,
    marginRight: (WIDTH / 100) * 2,
    flexDirection: "row",
    backgroundColor: "white",
  },
  BestBoxs: {
    // height: HEIGHT / 100 * 25,
    width: (WIDTH / 100) * 90,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#C4C4C4",
    // padding: WIDTH / 100 * 1,
    marginRight: (WIDTH / 100) * 2,
    flexDirection: "row",
    backgroundColor: "white",
  },
  bestText: {
    color: "#2B2B2D",
    fontSize: 15,
    fontWeight: "600"
  },
  bestText1: {
    marginBottom: (HEIGHT * 2) / 100,
    color: "#ADADAD",
    fontSize: 13,
    fontWeight: "400",
  },
  orgText: {
    color: "#F53E32",
    fontSize: 16,
    fontWeight: "600"
  },
  crsText: {
    color: "#7A7A7A",
    fontSize: 13,
    marginLeft: '5px',
    textDecorationLine: "line-through",
  },
  starCount: {
    fontSize: 11,
    color: "#999999",
  },
  buyBtn: {
    height: (HEIGHT / 100) * 4,
    width: "60px",
    backgroundColor: "#278BED",
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    marginRight: "5px",
  },
  buyText: {
    fontSize: 13,
    textAlign: "center",
    fontWeight: "600",
    color: "#FFFFFF",
  },
  offPart: {
    height: (HEIGHT / 100) * 37,
    width: (WIDTH / 100) * 15,
    // padding:WIDTH/100*3,
    marginRight: (WIDTH / 100) * 2,
    justifyContent: "space-evenly",
  },
  dealTitle: {
    color: "#DC2626",
    fontSize: 28,
  },
  dealTitle1: {
    color: "#8B96A5",
    fontSize: 16,
  },
  dayText: {
    fontSize: 16,
    color: "#FFFFFF",
  },
  dayText1: {
    fontSize: 12,
    color: "#FFFFFF",
  },

  dayImgBack: {
    height: (WIDTH / 100) * 2,
    width: (WIDTH * 3.75) / 100,
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 15,
    paddingBottom: 15,
    marginRight: (WIDTH / 100) * 0.5,
    marginTop: (HEIGHT / 100) * 0.5,
    marginBottom: (HEIGHT / 100) * 0.5,
    backgroundColor: "red",
    display: "flex",
  },
});

const HomePage = () => {
  const history = useNavigate();
  const dispatch = useDispatch<any>();
  const styles = useStyles();
  const [data, setData] = useState<any[]>([]);
  const [isAddToCartSuccess, setIsAddToCartSuccess] = useState(false);
  const deals = [
    {
      discount: "-35%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-35%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-05%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-45%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-35%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-15%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
    {
      discount: "-25%",
      image: require("../../../assets/Home/Cctv.png"),
      name: "Camera Name",
    },
  ];

  useEffect(() => {
    getContents();
  }, []);

  const getContents = async () => {
    // try {
    //   const response = await axiosPublicInstance.get(GET_LAYOUTS);
    //   if (response.status == 200) {
    //     setData(response.data);
    //   }
    // } catch (error) {
    //   console.error(error)
    // }

    try {
      const mockData = [
        // =======================
        // 1️⃣ Best Sellers
        // =======================
        {
          layoutId: 1,
          layoutTitle: "Best Sellers",
          productsList: {
            pageableProducts: {
              content: [
                {
                  id:101,
                  productId: 101,
                  displayName: "2 MP Built-in Mic Fixed Bullet Network Camera",
                  category: { categoryId: 1, categoryName: "CCTV Camera" },
                  salePrice: 3200,
                  mrpPrice: 4000,
                  averageRating: 4.5,
                  totalRatings: 128,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 20 }
                },
                {
                  id:102,
                  productId: 102,
                  displayName: "3 MP IR Bullet CCTV Camera",
                  category: { categoryId: 1, categoryName: "CCTV Camera" },
                  salePrice: 3600,
                  mrpPrice: 4500,
                  averageRating: 4.3,
                  totalRatings: 94,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 900 }
                },
                {
                  id:103,
                  productId: 103,
                  displayName: "4 MP Night Vision CCTV Camera",
                  category: { categoryId: 1, categoryName: "CCTV Camera" },
                  salePrice: 5200,
                  mrpPrice: 6000,
                  averageRating: 4.6,
                  totalRatings: 210,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 15 }
                },
                {
                  id:104,
                  productId: 104,
                  displayName: "5 MP Smart AI CCTV Camera",
                  category: { categoryId: 1, categoryName: "CCTV Camera" },
                  salePrice: 6900,
                  mrpPrice: 7800,
                  averageRating: 4.8,
                  totalRatings: 312,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 900 }
                },
                {
                  id:105,
                  productId: 105,
                  displayName: "5 MP Smart AI CCTV Camera",
                  category: { categoryId: 1, categoryName: "CCTV Camera" },
                  salePrice: 6900,
                  mrpPrice: 7800,
                  averageRating: 4.8,
                  totalRatings: 312,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 900 }
                }
              ]
            }
          }
        },

        // =======================
        // 2️⃣ Dome CCTV Cameras
        // =======================
        {
          layoutId: 2,
          layoutTitle: "Dome CCTV Cameras",
          productsList: {
            pageableProducts: {
              content: [
                {
                  productId: 201,
                  displayName: "2 MP Dome CCTV Camera",
                  category: { categoryId: 2, categoryName: "Dome Camera" },
                  salePrice: 2800,
                  mrpPrice: 3500,
                  averageRating: 4.1,
                  totalRatings: 65,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 20 }
                },
                {
                  productId: 202,
                  displayName: "4 MP Dome CCTV Camera",
                  category: { categoryId: 2, categoryName: "Dome Camera" },
                  salePrice: 4500,
                  mrpPrice: 5200,
                  averageRating: 4.2,
                  totalRatings: 87,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 700 }
                },
                {
                  productId: 203,
                  displayName: "5 MP IR Dome CCTV Camera",
                  category: { categoryId: 2, categoryName: "Dome Camera" },
                  salePrice: 6200,
                  mrpPrice: 7100,
                  averageRating: 4.6,
                  totalRatings: 143,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 12 }
                },
                {
                  productId: 204,
                  displayName: "8 MP Smart Dome CCTV Camera",
                  category: { categoryId: 2, categoryName: "Dome Camera" },
                  salePrice: 8900,
                  mrpPrice: 9900,
                  averageRating: 4.8,
                  totalRatings: 256,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 1000 }
                }
              ]
            }
          }
        },

        // =======================
        // 3️⃣ Bullet CCTV Cameras
        // =======================
        {
          layoutId: 3,
          layoutTitle: "Bullet CCTV Cameras",
          productsList: {
            pageableProducts: {
              content: [
                {
                  productId: 301,
                  displayName: "2 MP Bullet CCTV Camera",
                  category: { categoryId: 3, categoryName: "Bullet Camera" },
                  salePrice: 3100,
                  mrpPrice: 3800,
                  averageRating: 4.2,
                  totalRatings: 78,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 18 }
                },
                {
                  productId: 302,
                  displayName: "4 MP IR Bullet CCTV Camera",
                  category: { categoryId: 3, categoryName: "Bullet Camera" },
                  salePrice: 4800,
                  mrpPrice: 5600,
                  averageRating: 4.4,
                  totalRatings: 122,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 800 }
                },
                {
                  productId: 303,
                  displayName: "5 MP Bullet CCTV Camera",
                  category: { categoryId: 3, categoryName: "Bullet Camera" },
                  salePrice: 5800,
                  mrpPrice: 6500,
                  averageRating: 4.7,
                  totalRatings: 215,
                  productDiscount: { discountType: "PERCENTAGE", discountValue: 15 }
                },
                {
                  productId: 304,
                  displayName: "8 MP Smart Bullet CCTV Camera",
                  category: { categoryId: 3, categoryName: "Bullet Camera" },
                  salePrice: 9200,
                  mrpPrice: 10500,
                  averageRating: 4.9,
                  totalRatings: 340,
                  productDiscount: { discountType: "FIXED_AMOUNT", discountValue: 1300 }
                }
              ]
            }
          }
        }
      ];

      setData(mockData);

    } catch (error) {
      console.error(error)
    }
  };

  const ScrollContainer = styled(Box)({
    display: "flex",
    overflowX: "scroll",
    scrollbarWidth: "none", // Hide scrollbar for Firefox
    "&::-webkit-scrollbar": {
      display: "none", // Hide scrollbar for WebKit browsers
    },
    backgroundColor: "white",
  });

  const DealsAndOffers = () => {
    return (
      <>
        <Grid
          container
          spacing={3}
          style={{ backgroundColor: "white", padding: 2 }}
        >
          <Grid item xs={12} md={3}>
            <Box mt={4} mb={2}>
              <Typography variant="h6" align="left" style={{
                textTransform: 'uppercase',
              }} gutterBottom>
                Deals and offers
              </Typography>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Simplify Access Elevate Security
              </Typography>
            </Box>
            <Paper
              elevation={0}
              sx={{ padding: 0, backgroundColor: "transparent" }}
            >
              <Stack
                direction="row"
                display={"flex"}
                justifyContent="center"
                spacing={0}
              >
                <Paper
                  elevation={0}
                  sx={{
                    padding: 0,
                    color: "#fff",
                    backgroundColor: "transparent",
                  }}
                >
                  <Grid container>
                    <Grid item xs={2.5} style={{ marginRight: "10px" }}>
                      <Typography
                        variant="h6"
                        style={{
                          backgroundColor: "#c72a22",
                          textAlign: "center",
                          borderRadius: 10,
                        }}
                      >
                        04 Days
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5} style={{ marginRight: "10px" }}>
                      <Typography
                        variant="h6"
                        style={{
                          backgroundColor: "#c72a22",
                          textAlign: "center",
                          borderRadius: 10,
                        }}
                      >
                        13 Hour
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5} style={{ marginRight: "10px" }}>
                      <Typography
                        variant="h6"
                        style={{
                          backgroundColor: "#c72a22",
                          textAlign: "center",
                          borderRadius: 10,
                        }}
                      >
                        34 Mins
                      </Typography>
                    </Grid>
                    <Grid item xs={2.5} style={{ marginRight: "10px" }}>
                      <Typography
                        variant="h6"
                        style={{
                          backgroundColor: "#c72a22",
                          textAlign: "center",
                          borderRadius: 10,
                        }}
                      >
                        56 Secs
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Stack>
            </Paper>
          </Grid>
          <Grid item xs={12} md={9}>
            <ScrollContainer>
              {deals.map((deal, index) => (
                <Box
                  key={index}
                  sx={{ minWidth: 200, mx: 1, backgroundColor: "white" }}
                >
                  <Paper
                    sx={{
                      padding: 2,
                      textAlign: "center",
                      backgroundColor: "white",
                    }}
                    onClick={() => {
                      history("/productlist", {
                        state:
                          data &&
                            data[0] &&
                            data[0].productsList &&
                            data[0].productsList.pageableProducts &&
                            data[0].productsList.pageableProducts.content
                            ? data[0].productsList.pageableProducts.content
                            : data &&
                              data[1] &&
                              data[1].productsList &&
                              data[1].productsList.pageableProducts &&
                              data[1].productsList.pageableProducts.content
                              ? data[1].productsList.pageableProducts.content
                              : data &&
                                data[2] &&
                                data[2].productsList &&
                                data[2].productsList.pageableProducts &&
                                data[2].productsList.pageableProducts.content
                                ? data[2].productsList.pageableProducts.content
                                : [],
                      });
                    }}
                  >
                    <img
                      src={deal.image}
                      alt={deal.name}
                      style={{ width: "100%", height: "auto" }}
                    />
                    <Typography variant="h6" align="center">
                      {deal.name}
                    </Typography>
                    <Typography variant="h5" align="center" color="error">
                      {deal.discount}
                    </Typography>
                  </Paper>
                </Box>
              ))}
            </ScrollContainer>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <>
      {/* <StatusBar backgroundColor='#278BED' barStyle="dark-content" /> */}

      <Header />
      <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', marginTop: 15, }}>
        <Box
          flexDirection={"row"}
          style={{
            backgroundColor: "#fbfbfb",
            // width: (WIDTH * 90) / 100,
            // marginLeft: (WIDTH * 4.5) / 100,
            marginBottom: (HEIGHT * 6) / 100,
          }}
        >
          <>
            <Box className={styles.mainPart}>
              <Box
                sx={{
                  width: "100%",
                  overflow: "auto",
                  borderRadius: "4px",
                  padding: "10px",
                  boxShadow: 2,
                  border: "1px solid transparent",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
                style={{ marginTop: (HEIGHT / 100) * 1.5, display: "flex" }}
              >
                {BestSeller.map((item, index) => {
                  return (
                    <Box className={styles.BestBoxs} key={index}>
                      <Box
                        component="img"
                        style={{
                          height: (HEIGHT * 60) / 100,
                          width: (WIDTH * 90) / 100,
                        }}
                        src={require("../../../assets/Home/Banner.png")}
                      />
                    </Box>
                  );
                })}
              </Box>

              <Box
                style={{
                  marginTop: (HEIGHT / 100) * 4,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <label className={styles.titleText}>
                  {data && data[0] && data[0].layoutTitle
                    ? data[0].layoutTitle
                    : "Best Sellers"}
                </label>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  // overflow: "auto",
                  borderRadius: "4px",
                  // padding: "10px",
                  border: "1px solid transparent",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  marginBottom: (HEIGHT * 1) / 100,
                }}
                style={{ marginTop: (HEIGHT / 100) * 1.5, display: "flex" }}
              >
                <Grid2 container spacing={2}>
                  {data &&
                    data[0] &&
                    data[0].productsList &&
                    data[0].productsList.pageableProducts &&
                    data[0].productsList.pageableProducts.content
                    ? data[0].productsList.pageableProducts.content.map(
                      (item: any, index: any) => {
                        return (
                          <Grid2 size={{ xl: 2.4, lg: 2.4, md: 3, sm: 6, xs: 6 }}>
                            <ProductGridView product={item} showCompareBtn={false} />
                          </Grid2>
                        );
                      }
                    )
                    : null}
                </Grid2>
              </Box>
              <DealsAndOffers />

              <label
                style={{
                  marginTop: (HEIGHT / 100) * 4,
                  color: "#000000",
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  display: "block",
                  marginBottom: (HEIGHT / 100) * 1,
                }}
              >
                {data && data[1] && data[1].layoutTitle
                  ? data[1].layoutTitle
                  : "Dome CCTV Cameras"}
              </label>
              <Box
                style={{
                  marginTop: (HEIGHT / 100) * 1.5,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  component="img"
                  style={{
                    height: (HEIGHT * 56) / 100,
                    width: WIDTH < 400 ? (WIDTH * 60) / 100 : (WIDTH * 20) / 100,
                    borderRadius: 15,
                    // marginLeft: (WIDTH * 1) / 100,
                    marginRight: (WIDTH * 1) / 100,
                    marginTop: (HEIGHT * 2) / 100,
                  }}
                  src={require("../../../assets/Home/Banner1.png")}
                />
                <Box
                  sx={{
                    width: "100%",
                    // height: '300px',
                    // overflow: "auto",
                    borderRadius: "4px",
                    padding: "10px",
                    border: "1px solid transparent",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                  }}
                  style={{ display: "flex" }}
                >
                  <Grid2 container spacing={2}>

                    {data &&
                      data[1] &&
                      data[1].productsList &&
                      data[1].productsList.pageableProducts &&
                      data[1].productsList.pageableProducts.content &&
                      data[1].productsList.pageableProducts.content.splice(4)
                      ? data[1].productsList.pageableProducts.content.map(
                        (item: any, index: any) => {
                          return (
                            <Grid2 key={index} size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                              <ProductGridView showCompareBtn={false} product={item} />
                            </Grid2>
                          );
                        }
                      )
                      : null}
                  </Grid2>
                </Box>
              </Box>

              <label
                style={{
                  marginTop: (HEIGHT / 100) * 4,
                  color: "#000000",
                  marginBottom: (HEIGHT / 100) * 1,
                  fontSize: 20,
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  display: "block",
                }}
              >
                {data && data[2] && data[2].layoutTitle
                  ? data[2].layoutTitle
                  : "Bullet CCTV Cameras"}
              </label>
              <Box
                style={{
                  marginTop: (HEIGHT / 100) * 1.5,
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Box
                  component="img"
                  style={{
                    height: (HEIGHT * 56) / 100,
                    width: WIDTH < 400 ? (WIDTH * 60) / 100 : (WIDTH * 20) / 100,
                    borderRadius: 15,
                    // marginLeft: (WIDTH * 1) / 100,
                    marginRight: (WIDTH * 1) / 100,
                    marginTop: (HEIGHT * 2) / 100,
                  }}
                  src={require("../../../assets/Home/Banner1.png")}
                />
                <Box
                  sx={{
                    width: "100%",
                    // height: '300px',
                    overflow: "auto",
                    borderRadius: "4px",
                    padding: "10px",
                    border: "1px solid transparent",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                  }}
                  style={{ display: "flex" }}
                >
                  <Grid2 container spacing={2}>
                    {data &&
                      data[2] &&
                      data[2].productsList &&
                      data[2].productsList.pageableProducts &&
                      data[2].productsList.pageableProducts.content &&
                      data[2].productsList.pageableProducts.content.splice(4)
                      ? data[2].productsList.pageableProducts.content.map(
                        (item: any, index: any) => {
                          return (
                            <Grid2 key={index} size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                              <ProductGridView showCompareBtn={false} product={item} />
                            </Grid2>
                          );
                        }
                      )
                      : null}
                  </Grid2>
                </Box>
              </Box>

              <Grid2
                container
                spacing={2}
                className="algn"
                style={{ marginTop: 20 }}
              >
                <Grid2 size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}>
                  <Box
                    sx={{
                      boxShadow: 2,
                    }}
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      height: WIDTH < 400 ? "auto" : (HEIGHT * 28) / 100,
                      backgroundColor: "white",
                      // width:
                      //   WIDTH < 400 ? (WIDTH * 80) / 100 : (WIDTH * 28) / 100,
                    }}
                  >
                    <Grid2 direction={'row'} container spacing={{ lg: 2, md: 0, sm: 0 }}>
                      <Grid2 size={{ xl: 7, lg: 7, md: 5, sm: 6, xs: 6 }}>
                        <Box
                          style={{
                            // width: WIDTH < 400 ? "auto" : (WIDTH * 14) / 100,
                            // marginLeft: (WIDTH * 2) / 100,
                            marginLeft: 15,
                          }}
                        >
                          <Typography
                            style={{
                              color: "#DE0909",
                              fontWeight: "600",
                              marginTop: (HEIGHT * 4) / 100,
                            }}
                            variant="body2"
                          >
                            Need Any Assistance ?
                          </Typography>
                          <Typography variant="body2">Type Hi</Typography>
                          <Typography style={{ color: "grey" }} variant="body1">
                            To Get Instant Whatsapp Support
                          </Typography>
                          <Box
                            style={{
                              backgroundColor: "#DE0909",
                              width: '120px',
                              borderRadius: "20px",
                              marginTop: (HEIGHT * 2) / 100,
                              paddingTop: 2.9,
                              paddingBottom: 2.9,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              style={{
                                color: "white",
                                fontSize: 11,
                                fontWeight: "500",
                              }}
                            >
                              {"Whatsapp Now -->"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xl: 5, lg: 5, md: 7, sm: 6, xs: 6 }}>
                        <Box
                          component="img"
                          src={require("../../../assets/Home/whatsapp.jpg")}
                          style={{
                            height: (HEIGHT * 23) / 100,
                            width: WIDTH > 1000 ? "auto" : '180px',
                          }}
                        ></Box>
                      </Grid2>
                    </Grid2>


                  </Box>
                </Grid2>
                <Grid2 size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}>
                  <Box
                    sx={{
                      boxShadow: 2,
                    }}
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      height: WIDTH < 400 ? "auto" : (HEIGHT * 28) / 100,
                      backgroundColor: "white",
                      // width:
                      //   WIDTH < 400 ? (WIDTH * 80) / 100 : (WIDTH * 28) / 100,
                    }}
                  >
                    <Grid2 direction={'row'} container spacing={{ lg: 2, md: 0, sm: 0 }}>
                      <Grid2 size={{ xl: 7, lg: 7, md: 5, sm: 6, xs: 6 }}>
                        <Box
                          style={{
                            // width: WIDTH < 400 ? "auto" : (WIDTH * 14) / 100,
                            // marginLeft: (WIDTH * 2) / 100,
                            marginLeft: 15,
                          }}
                        >
                          <Typography
                            style={{
                              color: "#DE0909",
                              fontWeight: "600",
                              marginTop: (HEIGHT * 4) / 100,
                            }}
                            variant="body2"
                          >
                            Do you need in bulk?
                          </Typography>
                          <Typography variant="body2">
                            We are Always There{" "}
                          </Typography>
                          <Typography style={{ color: "grey" }} variant="body1">
                            Send your Query to Help You
                          </Typography>
                          <Box
                            style={{
                              backgroundColor: "#DE0909",
                              width: '120px',
                              borderRadius: "20px",
                              marginTop: (HEIGHT * 2) / 100,
                              paddingTop: 2.9,
                              paddingBottom: 2.9,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              style={{
                                color: "white",
                                fontSize: 11,
                                fontWeight: "500",
                              }}
                            >
                              {"SEND QUERY -->"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid2>
                      <Grid2 size={{ xl: 5, lg: 5, md: 7, sm: 6, xs: 6 }}>
                        <Box
                          component="img"
                          src={require("../../../assets/Home/query.jpg")}
                          style={{
                            height: (HEIGHT * 23) / 100,
                            width: WIDTH > 1000 ? "auto" : '180px',
                            // width: WIDTH < 400 ? "auto" : (WIDTH * 13) / 100,
                          }}
                        ></Box>
                      </Grid2>
                    </Grid2>
                  </Box>
                </Grid2>

                <Grid2 size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}>
                  <Link to="/tracknow" style={{ textDecoration: "none" }}>
                    <Box
                      sx={{ boxShadow: 2 }}
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        height: WIDTH < 400 ? "auto" : (HEIGHT * 28) / 100,
                        backgroundColor: "white",
                        // width:
                        //   WIDTH < 400 ? (WIDTH * 80) / 100 : (WIDTH * 28) / 100,
                        cursor: "pointer", // Add a pointer cursor to indicate clickable area
                      }}
                    >
                      <Grid2 direction={'row'} container spacing={{ lg: 2, md: 0, sm: 0 }}>
                        <Grid2 size={{ xl: 7, lg: 7, md: 5, sm: 6, xs: 6 }}>
                          <Box
                            style={{
                              // width: WIDTH < 400 ? "auto" : (WIDTH * 14) / 100,
                              marginLeft: 15,
                            }}
                          >

                            <Typography
                              style={{
                                color: "#DE0909",
                                fontWeight: "600",
                                marginTop: (HEIGHT * 4) / 100,
                              }}
                              variant="body2"
                            >
                              Don't Get Worried ?
                            </Typography>
                            <Typography variant="body2">Track Order</Typography>
                            <Typography style={{ color: "grey" }} variant="body1">
                              Track your order Any time Any where
                            </Typography>
                            <Box
                              style={{
                                backgroundColor: "#DE0909",
                                width: '120px',
                                borderRadius: "20px",
                                marginTop: (HEIGHT * 2) / 100,
                                paddingTop: 2.9,
                                paddingBottom: 2.9,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Typography
                                style={{
                                  color: "white",
                                  fontSize: 11,
                                  fontWeight: "500",
                                }}
                              >
                                {"Track Now -->"}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid2>
                        <Grid2 size={{ xl: 5, lg: 5, md: 7, sm: 6, xs: 6 }}>
                          <Box
                            component="img"
                            src={require("../../../assets/Home/tracks.jpg")}
                            style={{
                              height: (HEIGHT * 23) / 100,
                              width: WIDTH > 1000 ? "auto" : '180px',
                            }}
                          />
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Link>
                </Grid2>
              </Grid2>
            </Box>
          </>
          {isAddToCartSuccess && <SnackBarComponent />}
        </Box >
      </Container>
      <Footer />
    </>
  );
};

export default HomePage;
